"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TJ = void 0;
exports.TJ = {
    numericCode: '762',
    alpha2Code: 'TJ',
    alpha3Code: 'TJK',
    englishName: {
        short: 'Tajikistan',
        full: 'the Republic of Tajikistan',
    },
    names: {
        full: {
            en: 'the Republic of Tajikistan',
            fr: 'la République du Tadjikistan',
            tg: 'Tojikiston',
        },
        short: {
            en: 'Tajikistan',
            fr: 'Tadjikistan (le)',
            tg: 'Tojikiston',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'tg',
            languageAlpha3Code: 'tgk',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'TJ-KT': {
            numericCode: '762',
            code: 'TJ-KT',
            category: {
                id: '145',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tg: {
                        singular: 'viloyat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                tg: 'Khatlon',
            },
        },
        'TJ-SU': {
            numericCode: '762',
            code: 'TJ-SU',
            category: {
                id: '145',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tg: {
                        singular: 'viloyat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                tg: 'Sughd',
            },
        },
        'TJ-GB': {
            numericCode: '762',
            code: 'TJ-GB',
            category: {
                id: '315',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    tg: {
                        singular: 'viloyati mukhtor',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                tg: 'Kŭhistoni Badakhshon',
            },
        },
        'TJ-DU': {
            numericCode: '762',
            code: 'TJ-DU',
            category: {
                id: '458',
                names: {
                    en: {
                        singular: 'capital territory',
                        plural: 'capital territories',
                    },
                    fr: {
                        singular: 'territoire de la capitale',
                        plural: '',
                    },
                    tg: {
                        singular: 'viloyati poytakht',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                tg: 'Dushanbe',
            },
        },
        'TJ-RA': {
            numericCode: '762',
            code: 'TJ-RA',
            category: {
                id: '472',
                names: {
                    en: {
                        singular: 'districts under republic administration',
                        plural: 'districts under republic administration ',
                    },
                    fr: {
                        singular: "Districts sous l'administration de la République",
                        plural: '',
                    },
                    tg: {
                        singular: 'nohiyahoi tobei jumhurí',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                tg: 'nohiyahoi tobei jumhurí',
            },
        },
    },
    cities: [
        {
            name: 'Yovon',
            subdivision: 'Khatlon',
        },
        {
            name: 'Vose’',
            subdivision: 'Khatlon',
        },
        {
            name: 'Vakhsh',
            subdivision: 'Khatlon',
        },
        {
            name: 'Istaravshan',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Tursunzoda',
            subdivision: 'Republican Subordination',
        },
        {
            name: 'Qŭrghonteppa',
            subdivision: 'Khatlon',
        },
        {
            name: 'Panjakent',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Farkhor',
            subdivision: 'Khatlon',
        },
        {
            name: 'Vahdat',
            subdivision: 'Republican Subordination',
        },
        {
            name: 'Norak',
            subdivision: 'Khatlon',
        },
        {
            name: 'Kŭlob',
            subdivision: 'Khatlon',
        },
        {
            name: 'Kolkhozobod',
            subdivision: 'Khatlon',
        },
        {
            name: 'Khorugh',
            subdivision: 'Gorno-Badakhshan',
        },
        {
            name: 'Ishqoshim',
            subdivision: 'Gorno-Badakhshan',
        },
        {
            name: 'Hisor',
            subdivision: 'Republican Subordination',
        },
        {
            name: 'Dushanbe',
            subdivision: 'Dushanbe',
        },
        {
            name: 'Danghara',
            subdivision: 'Khatlon',
        },
        {
            name: 'Chubek',
            subdivision: 'Khatlon',
        },
        {
            name: 'Boshkengash',
            subdivision: 'Dushanbe',
        },
        {
            name: 'Proletar',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Khŭjand',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Konibodom',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Isfara',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Chkalov',
            subdivision: 'Viloyati Sughd',
        },
        {
            name: 'Moskovskiy',
            subdivision: 'Khatlon',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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